module.exports = __webpack_public_path__ + "img/patent_10.30398e1.jpg";